


















































import { Vue, Component, Watch } from "vue-property-decorator";
import logger from "@/configs/logger";

import "./styles/public-footer.scss";

@Component
export default class PublicFooter extends Vue {}
